module.exports = __webpack_public_path__ + "img/office1.c2d2bf28.png";